// TODO: add props
import React from 'react';
import { getContext } from 'common';
import Styled from './styles';

/** `SideDrawerItemDivider` is made to be used as child of `SideDrawerList`. All props will be provided to the root element */
const SideDrawerItemDivider = React.forwardRef((props, ref) =>
  getContext(({ RTL, theme }) => <Styled.SideDrawerItemDivider {...props} $theme={theme.LIST.VERTICAL} ref={ref} RTL={RTL} />));

SideDrawerItemDivider.displayName = 'SideDrawerItemDivider';

export default SideDrawerItemDivider;
